import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
  AnalyticsPageViewCreateRequest
} from '../../../../server/services/analytics/pageView/create.contract';

@Injectable({
  providedIn: 'root'
})
export class PageViewTrackingService {
  private visitorId: string;

  constructor(private router: Router) {
    this.visitorId = this.getOrCreateVisitorId();
  }

  init(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.trackPageView(event.urlAfterRedirects || event.url);
    });
  }

  private async trackPageView(path: string): Promise<void> {
    try {
      await new AnalyticsPageViewCreateRequest({
        path,
        source: 'web-app',
        platform: 'web',
        visitorId: this.visitorId
      }).execute();
    } catch (e) {
      // Silently fail - tracking should not break the app
    }
  }

  private getOrCreateVisitorId(): string {
    const key = 'yoggl_visitor_id';
    let id = localStorage.getItem(key);
    if (!id) {
      id = this.generateUUID();
      localStorage.setItem(key, id);
    }
    return id;
  }

  private generateUUID(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
